import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// AntD's `lg` breakpoint is 992px. We treat anything below that as "mobile/tablet"
// for the purposes of layout (drawer sider, compact header, etc).
export const useIsMobile = () => useMediaQuery('(max-width: 991.98px)');
export const useIsCompact = () => useMediaQuery('(max-width: 575.98px)');
